export default __webpack_public_path__ + "static/media/330_business02-en-web.73fee4f0.png";